<template>
  <div class="m-index">
    <Search :renderData="renderData" :formData="form" @onSearch="onSearch" :unfold="true" >
      <el-button slot="btn" @click="onExport" :loading="exportLoading">导出</el-button>
    </Search>
    <div class="fun-btn-box">
      <auth-button auth="market:coupon:share:data:export">
        <el-button type="primary" class="fun-btn mr10" @click="()=>{this.exportCouponDistributionDataDialog = true}">券分销数据导出</el-button>
      </auth-button>
    </div>
    <Table
      :loading="loading"
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #refId="{ row }">{{ row.refId }}</template>
      <template #phone="{ row, scope }">
        <span :key="tableKey" v-if="row.phone">{{row.phone_show || row.phone }}</span>
        <span  v-else>---</span>
        <auth-button auth="user:phone:read">
          <el-button v-if="row.phone" class="look-phone-btn" type="text" @click="onLookPhone(row, scope.$index)">
            {{ row.phone_show ? '隐藏' : '查看' }}
          </el-button>
        </auth-button>
      </template>
      <template #mallName="{ row }">{{ row.mallName?row.mallName:'---' }}</template>
      <template #point="{ row }">{{ row.point?row.point:'0' }}</template>
      <template #levelName="{ row }">{{ row.levelName?row.levelName:'---' }}</template>
      <template #registerTime="{ row }">{{ row.registerTime ? $moment(row.registerTime).format('YYYY/MM/DD') : '---' }}</template>
      <template #platform="{ row }">{{ row.platform }}</template>
      <template #locationDetail="{ row }">{{ row.locationDetail || '---' }}</template>
      <template #nickname="{ row }">{{ row.nickname?row.nickname:'---' }}</template>
      <template #birthday="{ row }">{{ row.birthday ? row.birthday : '---' }}</template>
      <template #operation="{ scope }">
        <el-button type="text" @click="goDetail(scope.row)" >查看详情</el-button >
        <auth-button auth="member:level:update">
          <el-button type="text" @click="levelUpdate(scope.row)" class="ml10" v-if="scope.row.phone">等级调整</el-button>
        </auth-button>
        <auth-button auth="member:point:update">
          <el-button type="text" @click="integralUpdate(scope.row)" class="ml10" v-if="scope.row.phone">积分调整</el-button>
        </auth-button>
      </template>
    </Table>
    <Dialog :maskClose="false" :dialogShow="levelDialogShow" title="等级调整" @maskClick="() => {levelDialogShow = false}">
      <template>
        <div class="level-update">
          <el-form :hide-required-asterisk="true" ref="levelForm" :rules="levelFormFule" :model="levelForm" label-width="80px">
            <el-form-item label="等级调整" prop="levelId"  >
              <el-select v-model="levelForm.levelId" placeholder="请选择会员等级"   collapse-tags clearable>
                <el-option v-for="(item, index) in renderData[0].option" :label="item.label" :value="item.value" :key="index" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注" prop="remark" >
              <el-input  type="textarea" rows="6" v-model="levelForm.remark" placeholder="请输入备注" maxlength="2000" show-word-limit />
            </el-form-item>
          </el-form>
          <div class="button-div">
            <el-row class="button-div-row">
              <el-button type="default" class="cancel" @click="() => {levelDialogShow = false}">取消</el-button>
              <el-button type="primary" :loading="levelDialogLoading" class="determine" @click="determineLevel">确定</el-button>
            </el-row>
          </div>
        </div>
      </template>
    </Dialog>
    <Dialog :maskClose="false" :dialogShow="integralDialogShow" title="积分调整" @maskClick="() => {integralDialogShow = false}">
      <template>
        <div class="integral-update">
          <el-radio-group v-model="integralForm.type">
            <el-radio label="up">增加积分</el-radio>
            <el-radio label="down">扣减积分</el-radio>
          </el-radio-group>
          <el-form :hide-required-asterisk="true" ref="integralForm" :model="integralForm" label-width="80px">
            <el-row>
              <el-col :span="21">
                <el-form-item label="积分调整" prop="points" :rules="[{ required: true, message: '积分不能为空'},]">
                  <el-input v-model="integralForm.points" type="text" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <div class="tips">分</div>
              </el-col>
            </el-row>
          </el-form>
          <div class="button-div">
            <el-row class="button-div-row">
              <el-button type="default" class="cancel" @click="() => {integralDialogShow = false}">取消</el-button>
              <el-button type="primary" :loading="integralDialogLoading"  class="determine" @click="determineIntegral">确定</el-button>
            </el-row>
          </div>
        </div>
      </template>
    </Dialog>
    <el-dialog v-if="exportCouponDistributionDataDialog" :visible="exportCouponDistributionDataDialog" title="券分销数据导出" width="35%" :show-close="false">
      <el-form ref="exportCouponDistributionDataFrom" :model="exportCouponDistributionDataFrom" label-width="80px" >
        <el-form-item label="选择时间" prop="dataTime" >
          <el-date-picker
            v-model="exportCouponDistributionDataFrom.dataTime"
            type="datetimerange"
            range-separator=""
            format="yyyy/MM/dd HH:mm:ss"
            value-format="timestamp"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="" prop="" >
          <span class="input-remark">（*未选时间导出全部数据）</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportCouponDistributionDataCancel">取 消</el-button>
        <el-button type="primary" @click="exportCouponDistributionDataSubmit" :loading="exportCouponDistributionDataLoading">{{exportCouponDistributionDataLoading?'导出中...':'确 定'}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import Dialog from "@/components/Dialog/index";
import { api_getListMember, api_putULevel, api_putUPoint, api_postMemberExport , api_getCouponDistributionDataExport } from '@/api/member'
import { api_getListLevelNoPage, api_getUserPhone } from '@/api/common'
import { downFile } from "@/utils";
import { formatArrTime } from '@/utils/index'
import tableList from '@/mixins/tableList';
import aes from '@/common/aes.js'
export default {
  name: "mIndex",
  mixins: [tableList],
  components: {
    AuthButton,
    Search,
    Table,
    Dialog
  },
  data() {
    return {
      renderData: [
        {
          label: "会员等级",
          placeholder: "请选择会员等级",
          type: "select",
          multiple: false,
          key: "levelId",
          option: [],
        },
        {
          label: "手机号",
          placeholder: "请输入手机号",
          type: "input",
          key: "phone",
          isNumber: true,
          maxLength: 11
        },
        {
          label: "注册时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "loginTime",
        },
        {
          label: "注册来源",
          placeholder: "请选择注册来源",
          type: "select",
          multiple: false,
          key: "platform",
          option: [{
            value: 'WechatMiniapp',
            label: '微信小程序'
          },{
            value: 'AlipayMiniapp',
            label: '支付宝小程序'
          }],
        }
      ],
      form: {
        levelId: "",
        phone: "",
        loginTime: [],
        source: ''
      },
      tableThData: [
        // { prop: "refId", label: "会员ID", minWidth: "120", },
        { prop: "phone", label: "手机号", minWidth: "150", },
        { prop: "mallName", label: "所属商场", minWidth: "150", },
        { prop: "point", label: "积分", minWidth: "80", },
        { prop: "nickname", label: "昵称", minWidth: "120", },
        { prop: "levelName", label: "会员等级", minWidth: "100", },
        { prop: "registerTime", label: "注册时间", minWidth: "100", },
        { prop: "platform", label: "注册来源", minWidth: "100", },
        { prop: "locationDetail", label: "地址", minWidth: "120", },
        { prop: "birthday", label: "生日", minWidth: "100", },
        { prop: "operation", label: "操作", minWidth: "230", },
      ],
      levelDialogShow: false,
      integralDialogShow: false,
      levelDialogLoading: false,
      integralDialogLoading: false,
      levelForm: {

      },
      levelFormFule:{
        levelId: [{ required: true, message: '请选择会员等级' }],
        remark: [{ required: true, message: '请输入备注' }],
      },
      integralForm: {
        type: 'up',
        points: '',
        id: ''
      },
      exportCouponDistributionDataDialog:false,
      exportCouponDistributionDataFrom:{dataTime:[]},
      exportCouponDistributionDataLoading:false,
      tableKey: false,
      exportLoading: false
    };
  },
  created () {
    this.getListLevel()
  },
  methods: {
    // 点击导出
    async onExport() {
      this.exportLoading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      let {start, end} = formatArrTime(this.form.loginTime, 'YYYY-MM-DD HH:mm:ss')
      try {
        let res2 = await api_postMemberExport({levelId: this.form.levelId, phone: this.form.phone, loginBeginTime: start, loginEndTime: end, limit: this.limit, offset: this.offset, platform: this.form.platform })
        downFile(res2)
        this.exportLoading = false
      } catch (error) {
        this.exportLoading = false
      }
    },
    goDetail (row) {
      console.log('查看详情')
      this.$router.push({
        path: '/member/index/detail?id=' + row.id
      })
    },
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      let {start, end} = formatArrTime(this.form.loginTime, 'YYYY-MM-DD HH:mm:ss')
      const data = await api_getListMember({levelId: this.form.levelId, phone: this.form.phone, loginBeginTime: start, loginEndTime: end, limit: this.limit, offset: this.offset, platform: this.form.platform })
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },
    // 获取会员等级
    async getListLevel () {
      const data = await api_getListLevelNoPage()
      const list = data.map((item) => {
        let obj = {
          label: item.name,
          value: item.id
        }
        return obj
      })
      this.renderData[0].option = list
    },
    lookDetaile(row) {
    },

    // 点击调整等级确认按钮
    determineLevel () {
      this.$refs.levelForm.validate(async (valid) => {
        if (valid) {
          this.levelDialogLoading = true
          try {
            await api_putULevel({...this.levelForm})
            this.levelDialogLoading = false
            this.levelDialogShow = false
            this.getList()
            this.$baseMessage('操作成功', 'success')
          } catch (error) {
            this.levelDialogLoading = false
          }
        } else {
          return false
        }
      })
    },
    // 点击调整积分确认按钮
    determineIntegral () {
      this.$refs.integralForm.validate(async (valid) => {
        if (valid) {
          this.integralDialogLoading = true
          try {
            await api_putUPoint({...this.integralForm})
            this.integralDialogLoading = false
            this.integralDialogShow = false
            this.getList()
            this.$baseMessage('操作成功', 'success')
          } catch (error) {
            this.integralDialogLoading = false
          }
        } else {
          return false
        }
      })
    },
    // 点击调整等级按钮
    levelUpdate (row) {
      this.levelDialogShow = true
      this.levelForm={
        levelId:null,
        remark:''
      }
      this.levelForm.id = row.id
    },

    // 点击调整积分
    integralUpdate (row) {
      this.integralDialogShow = true
      this.integralForm = {
        type: 'up',
        points: '',
        id: ''
      }
      this.integralForm.id = row.id
    },
 async exportCouponDistributionDataSubmit(){
          this.exportCouponDistributionDataLoading = true
          let [actionTimeFrom,actionTimeTo]  = this.exportCouponDistributionDataFrom.dataTime?this.exportCouponDistributionDataFrom.dataTime:[]
            let params = {
                actionTimeFrom,
                actionTimeTo
            }
            try {
              this.$router.push({query: params})
              let res = await api_getCouponDistributionDataExport(params)
              downFile(res)
              this.exportCouponDistributionDataDialog = false
              this.exportCouponDistributionDataFrom = {
                dataTime:[]
              }
            } catch (error) {
              console.log(error)
            }
          this.exportCouponDistributionDataLoading = false
    },
    exportCouponDistributionDataCancel(){
      this.exportCouponDistributionDataDialog = false
      this.exportCouponDistributionDataFrom = {
        dataTime:[]
      }
    },
    // 点击查看手机号
    async onLookPhone(row, index) {
      try {
        if (row.phone_show) {
          delete this.tableTrData[index].phone_show
        } else {
          const {phone} = await api_getUserPhone({id: row.id})
          this.tableTrData[index].phone_show = aes.decrypt(phone)
        }
        this.tableKey = !this.tableKey
      } catch (error) {}
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.m-index {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  .look-detaile{
    font-size: 10px;
    font-weight: 400;
    color: #1A5CF5;
    line-height: 14px;
  }
  .level-update, .integral-update{
    margin-top: 22px;
    ::v-deep{
      .el-radio__label{
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
      }
      .el-radio__input.is-checked + .el-radio__label{
        color: #05C8AF;
      }
      .el-form{
        margin-top: 33px;
        .el-form-item__label{
          color: #333;
          font-size: 16px;
        }
        .el-input{
          border-radius: 2px;
          font-size: 16px;
          .el-input__inner{
            background: #F2F3F5;
            border: 0;
          }
          .el-input__inner:focus{
            background: #fff;
            border: 1px solid #05C8AF;
          }
        }
        .el-input.is-focus{
          .el-input__inner{
            background: #fff;
          }
        }
        .tips{
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          line-height: 40px;
          margin-left: 20px
        }
      }
    }
    .button-div{
      overflow: hidden;
      float: right;
      margin-top: 33px;
      button{
        border: 0;
        width: 110px;
        height: 40px;
        border-radius: 2px;
        font-size: 16px;
      }
      .cancel{
        background: #F2F3F5;
        color: #666666;
      }
    }
  }

  .input-remark {
    height: 17px;
    line-height: 17px;
    font-size: 12px;
    color: #999999;
  }
  .fun-btn-box {
    margin-top: 20px;
  }
}
</style>
